import React from 'react';
import { clientChargeBreakdown, formatMoney } from '../../utils/clientTransactionCharge';

const ChargeSummary = ({ amount, percent, mode = 'deposit' }) => {
    const breakdown = clientChargeBreakdown(amount, percent);

    return (
        <div className="space-y-3 text-sm">
            <div className="flex justify-between">
                <span className="text-gray-600">Amount entered</span>
                <span className="font-semibold">{formatMoney(breakdown.gross)}</span>
            </div>
            <div className="flex justify-between">
                <span className="text-gray-600">Charge ({breakdown.percent}%)</span>
                <span className="font-semibold">{formatMoney(breakdown.chargeAmount)}</span>
            </div>
            {mode === 'withdraw' && (
                <div className="flex justify-between">
                    <span className="text-gray-600">Wallet debit</span>
                    <span className="font-semibold">{formatMoney(breakdown.gross)}</span>
                </div>
            )}
            <hr className="border-gray-200" />
            <div className="flex justify-between text-base">
                <span className="font-semibold">{mode === 'withdraw' ? 'Amount you receive' : 'Amount credited'}</span>
                <span className="font-bold text-green-600">{formatMoney(breakdown.net)}</span>
            </div>
        </div>
    );
};

export default ChargeSummary;
